import React from 'react';
import { View } from 'react-native';
import { NavigationTabBarItem, Icon, Theme } from 'fitbeat.react-native-components';
import HamburgerIcon from '../../../assets/hamburger.svg';
import NutritionIcon from '../../../assets/Nutrition.svg';
import WorkoutIcon from '../../../assets/workout.svg';

const isMobile = window.innerWidth <= 550;

export const TitleTabBar = ({ navigation }) => {
  const { state } = navigation;
  const { routeName } = state;

  const routes = [{
    title: 'Home',
    navigationRoute: 'SummaryDashboard',
    icon: (color) => (
      <Icon
        size={30}
        name='ios-home-outline'
        style={{ color }}
      />
    ),
  }, {
    title: 'Workouts',
    navigationRoute: 'UserDashboard',
    icon: (color) => (
      <WorkoutIcon
        height={25}
        width={30}
        stroke={color}
        strokeWidth={0.7}
      />
    ),
  }, {
    title: 'Meals',
    navigationRoute: 'Nutrition',
    icon: (color) => (
      <NutritionIcon height={30} width={30} color={color} />
    ),
  }, {
    title: 'Progress',
    navigationRoute: 'StatsScreen',
    icon: (color) => (
      <Icon
        size={30}
        name='ios-stats-outline'
        style={{ color }}
      />
    ),
  }];

  if (isMobile) {
    routes.push({
      title: 'More',
      navigationRoute: 'Profile',
      icon: (color) => (
        <HamburgerIcon height={30} width={30} color={color} />
      ),
    });
  }

  return (
    routes.map((route, index) => {
      const isActive = routeName === route.navigationRoute;
      const tintColor = isActive ? Theme.PRIMARY : Theme.CHARCOAL;
      return (
        <View style={[{
          flex: 1,
          paddingHorizontal: isMobile ? 0 : 40,
        }, isMobile && { height: 90 }]}
        >
          <NavigationTabBarItem
            isRouteActive={isActive}
            onPress={() => navigation.navigate(route.navigationRoute)}
            isLastRoute={index === routes.length - 1}
            icon={route.icon(tintColor)}
            title={route.title}
            titleColour={tintColor}
            isMobile={isMobile}
            customStyles={{
              containerStyle: !isMobile && { borderTopWidth: 0 },
              innerStyle: !isMobile && { flexDirection: 'row', paddingHorizontal: 10, borderRightWidth: 0 },
              labelStyle: !isMobile && { paddingLeft: 10 },
              iconContainerStyle: isMobile && { flex: 1 },
            }}
          />
        </View>
      );
    })
  );
};
